
    import "src/app/AppSeller/SettingsPage/Warehouses/components/WarehouseCard/index.module.scss?farm_css_modules";
    
    export default {"address": `address-b4d5cba1`,"invoicePrefix": `invoicePrefix-b4d5cba1`,"left": `left-b4d5cba1`,"warehouseCard": `warehouseCard-b4d5cba1`,"warehouseCardInnerContainer": `warehouseCardInnerContainer-b4d5cba1`,"warehouseId": `warehouseId-b4d5cba1`,"warehouseType": `warehouseType-b4d5cba1`}
    